module.exports = __webpack_public_path__ + "static/pharmsource-f7ca851d3bccb5b1138cdb75720473ee.png";